import { 
  Box, 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Chip,
  Avatar
} from '@mui/material';
import {
  LocationCity as LocalIcon,
  Public as NationalIcon,
  Business as CorporateIcon,
  School as EducationIcon,
  CheckCircle as CheckIcon,
  TrendingUp as GrowthIcon,
  Speed as SpeedIcon,
  AttachMoney as MoneyIcon,
  Security as SecurityIcon,
  Support as SupportIcon,
  Article as NewsIcon,
  Language as GlobalIcon
} from '@mui/icons-material';
import { useState } from 'react';

const SolutionsPage = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  // Çözüm Kategorileri
  const solutions = [
    {
      icon: <LocalIcon sx={{ fontSize: 60 }} />,
      title: "Yerel Haber Portalları",
      subtitle: "Şehrinizin Dijital Sesi",
      description: "İl, ilçe veya bölge bazlı yerel habercilik için özel olarak tasarlandı. Yerel reklamverenler, belediye ilanları ve bölgesel içerik yönetimi",
      color: "#1e40af",
      gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
      features: [
        "Yerel haber kategorileri",
        "Belediye ilan entegrasyonu",
        "Bölgesel hava durumu widget",
        "Yerel etkinlik takvimi",
        "Mahalle bazlı haber filtreleme",
        "Yerel reklamveren yönetimi",
        "Şehir rehberi entegrasyonu",
        "Yerel spor skorları"
      ],
      stats: [
        { value: "500+", label: "Yerel Haber Sitesi" },
        { value: "50K+", label: "Günlük Okuyucu" },
        { value: "%85", label: "Yerel Reklam Geliri" }
      ],
      useCases: [
        "İl ve ilçe haber siteleri",
        "Bölgesel haber ajansları",
        "Mahalle gazeteleri",
        "Yerel sivil toplum kuruluşları"
      ]
    },
    {
      icon: <NationalIcon sx={{ fontSize: 60 }} />,
      title: "Ulusal Haber Siteleri",
      subtitle: "Türkiye Geneli Yayın",
      description: "Yüksek trafikli ulusal haber platformları için ölçeklenebilir altyapı. Çoklu editör, ajans entegrasyonu ve gelişmiş analitik",
      color: "#dc2626",
      gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
      features: [
        "Çoklu editör ve yazar yönetimi",
        "Haber ajansı otomasyonu (AA, İHA, DHA)",
        "Canlı yayın ve breaking news",
        "Çoklu kategori yönetimi",
        "Gelişmiş analitik ve raporlama",
        "Yüksek trafik optimizasyonu",
        "Video haber yönetimi",
        "Sosyal medya entegrasyonu"
      ],
      stats: [
        { value: "100+", label: "Ulusal Platform" },
        { value: "5M+", label: "Günlük Ziyaretçi" },
        { value: "99.9%", label: "Uptime Garantisi" }
      ],
      useCases: [
        "Ulusal haber siteleri",
        "Online gazeteler",
        "Dijital yayın kuruluşları",
        "Haber ajansları"
      ]
    },
    {
      icon: <CorporateIcon sx={{ fontSize: 60 }} />,
      title: "Kurumsal İletişim",
      subtitle: "Şirket İçi Haber Merkezi",
      description: "Kurumsal iletişim, PR ve marka yayıncılığı için özel çözümler. Çalışan portalı, basın bültenleri ve kurumsal blog yönetimi",
      color: "#059669",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
      features: [
        "Kurumsal haber merkezi",
        "Basın bülteni yönetimi",
        "Çalışan portalı entegrasyonu",
        "Marka yayıncılığı araçları",
        "PR kampanya yönetimi",
        "Medya kiti hazırlama",
        "İç iletişim platformu",
        "Kurumsal blog sistemi"
      ],
      stats: [
        { value: "200+", label: "Kurumsal Müşteri" },
        { value: "10K+", label: "Çalışan Kullanıcı" },
        { value: "%95", label: "Memnuniyet Oranı" }
      ],
      useCases: [
        "Kurumsal haber merkezleri",
        "PR ve iletişim ajansları",
        "Şirket içi haber platformları",
        "Marka yayıncılığı"
      ]
    },
    {
      icon: <EducationIcon sx={{ fontSize: 60 }} />,
      title: "Eğitim ve Araştırma",
      subtitle: "Akademik Yayın Platformu",
      description: "Üniversiteler, araştırma merkezleri ve akademik yayın platformları için özelleştirilmiş çözümler",
      color: "#7c3aed",
      gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
      features: [
        "Akademik makale yönetimi",
        "Araştırma projesi duyuruları",
        "Etkinlik ve seminer takvimi",
        "Öğrenci ve öğretim üyesi profilleri",
        "Yayın arşivi sistemi",
        "Çoklu kampüs desteği",
        "Akademik takvim entegrasyonu",
        "Bilimsel içerik kategorileri"
      ],
      stats: [
        { value: "150+", label: "Eğitim Kurumu" },
        { value: "100K+", label: "Öğrenci Erişimi" },
        { value: "5K+", label: "Akademik Yayın" }
      ],
      useCases: [
        "Üniversite haber siteleri",
        "Akademik yayın platformları",
        "Araştırma merkezleri",
        "Eğitim kurumları"
      ]
    }
  ];

  // Ortak Avantajlar
  const commonBenefits = [
    {
      icon: <SpeedIcon />,
      title: "Hızlı Kurulum",
      description: "7 gün içinde yayında. Kurulum, eğitim ve içerik aktarımı dahil"
    },
    {
      icon: <MoneyIcon />,
      title: "Maliyet Tasarrufu",
      description: "Kendi yazılımınızı geliştirmekten %70 daha uygun"
    },
    {
      icon: <SecurityIcon />,
      title: "Güvenli Altyapı",
      description: "Banka seviyesinde güvenlik, otomatik yedekleme ve DDoS koruması"
    },
    {
      icon: <SupportIcon />,
      title: "Türkçe Destek",
      description: "7/24 Türkçe teknik destek, video eğitimler ve dokümantasyon"
    },
    {
      icon: <GrowthIcon />,
      title: "Ölçeklenebilir",
      description: "Trafiğiniz arttıkça sistem otomatik büyür. Sınır yok"
    },
    {
      icon: <GlobalIcon />,
      title: "Çok Dilli",
      description: "Türkçe ve İngilizce hazır. Yeni dil eklemek çok kolay"
    }
  ];

  // Başarı Hikayeleri
  const successStories = [
    {
      company: "İstanbul Haber",
      type: "Yerel Haber Portalı",
      result: "Günlük ziyaretçi sayısı 3 ayda %250 arttı",
      quote: "Eski sistemimizde sayfa tasarlamak saatler alıyordu. Şimdi 10 dakikada istediğim tasarımı yapıyorum.",
      author: "Ahmet Yılmaz",
      position: "Genel Yayın Yönetmeni",
      color: "#1e40af"
    },
    {
      company: "Türkiye Gündem",
      type: "Ulusal Haber Sitesi",
      result: "Sayfa yükleme hızı %80 iyileşti, SEO sıralaması 2 kat arttı",
      quote: "Ajans botları sayesinde günde 500+ haber otomatik çekiliyor. Editörlerimiz sadece önemli haberlere odaklanıyor.",
      author: "Ayşe Demir",
      position: "Dijital Medya Direktörü",
      color: "#dc2626"
    },
    {
      company: "TechCorp Haber Merkezi",
      type: "Kurumsal İletişim",
      result: "Çalışan etkileşimi %400 arttı, basın bülteni hazırlama süresi %60 azaldı",
      quote: "Hem iç iletişim hem de dış basın için tek platform kullanıyoruz. Çok pratik.",
      author: "Mehmet Kaya",
      position: "İletişim Müdürü",
      color: "#059669"
    }
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.2) 0%, transparent 50%)
            `,
            pointerEvents: 'none'
          }
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.9rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                color: '#60a5fa',
                mb: 2,
                display: 'block',
                textTransform: 'uppercase'
              }}
            >
              ÇÖZÜMLER
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '4.5rem' },
                fontWeight: 800,
                mb: 4,
                color: 'white',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                lineHeight: 1.1
              }}
            >
              Her İhtiyaca Özel Çözüm
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                color: 'rgba(255,255,255,0.9)',
                maxWidth: 800,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                mb: 6
              }}
            >
              Yerel haber sitesinden ulusal platforma, kurumsal iletişimden akademik yayına. 
              Her sektör için özelleştirilmiş haber yönetim çözümleri
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Çözümler Grid */}
      <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
        <Container maxWidth="xl">
          <Grid container spacing={6}>
            {solutions.map((solution, index) => (
              <Grid item xs={12} key={index}>
                <Paper
                  elevation={0}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: { xs: 4, md: 6 },
                    background: '#ffffff',
                    border: '2px solid #e2e8f0',
                    borderRadius: 4,
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 6,
                      background: solution.gradient,
                      transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.4s ease'
                    },
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 30px 60px ${solution.color}20, 0 15px 30px rgba(0, 0, 0, 0.1)`,
                      borderColor: solution.color
                    }
                  }}
                >
                  <Grid container spacing={4} alignItems="center">
                    {/* Sol Taraf - İçerik */}
                    <Grid item xs={12} md={8}>
                      {/* Icon & Title */}
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 100,
                            height: 100,
                            borderRadius: 3,
                            background: `${solution.color}15`,
                            color: solution.color,
                            mr: 3,
                            transition: 'all 0.4s ease',
                            transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
                          }}
                        >
                          {solution.icon}
                        </Box>
                        <Box>
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 800,
                              mb: 1,
                              color: '#1e293b',
                              fontSize: { xs: '1.8rem', md: '2.5rem' },
                              fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                            }}
                          >
                            {solution.title}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              background: solution.gradient,
                              backgroundClip: 'text',
                              WebkitBackgroundClip: 'text',
                              WebkitTextFillColor: 'transparent',
                              fontSize: '1.2rem'
                            }}
                          >
                            {solution.subtitle}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Description */}
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#64748b',
                          lineHeight: 1.8,
                          mb: 4,
                          fontSize: '1.1rem'
                        }}
                      >
                        {solution.description}
                      </Typography>

                      {/* Features Grid */}
                      <Grid container spacing={2} sx={{ mb: 4 }}>
                        {solution.features.map((feature, idx) => (
                          <Grid item xs={12} sm={6} key={idx}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <CheckIcon sx={{ color: solution.color, fontSize: 20, mr: 1.5 }} />
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#475569',
                                  fontWeight: 500,
                                  fontSize: '0.95rem'
                                }}
                              >
                                {feature}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>

                      {/* Use Cases */}
                      <Box sx={{ mb: 3 }}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: '#1e293b',
                            mb: 2,
                            fontSize: '0.9rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                          }}
                        >
                          Kimler Kullanıyor?
                        </Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                          {solution.useCases.map((useCase, idx) => (
                            <Chip
                              key={idx}
                              label={useCase}
                              size="small"
                              sx={{
                                background: `${solution.color}10`,
                                color: solution.color,
                                fontWeight: 600,
                                fontSize: '0.85rem',
                                mb: 1
                              }}
                            />
                          ))}
                        </Stack>
                      </Box>

                      {/* CTA Button */}
                      <Button
                        variant="contained"
                        size="large"
                        sx={{
                          background: solution.gradient,
                          color: 'white',
                          px: 4,
                          py: 1.5,
                          fontSize: '1rem',
                          fontWeight: 600,
                          borderRadius: 2,
                          textTransform: 'none',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: `0 10px 30px ${solution.color}40`
                          },
                          transition: 'all 0.3s ease'
                        }}
                      >
                        Detaylı Bilgi Al
                      </Button>
                    </Grid>

                    {/* Sağ Taraf - İstatistikler */}
                    <Grid item xs={12} md={4}>
                      <Box
                        sx={{
                          background: `linear-gradient(135deg, ${solution.color}08, ${solution.color}15)`,
                          borderRadius: 3,
                          p: 4,
                          border: `1px solid ${solution.color}30`
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            mb: 3,
                            color: '#1e293b',
                            textAlign: 'center'
                          }}
                        >
                          Rakamlarla Başarı
                        </Typography>
                        <Stack spacing={3}>
                          {solution.stats.map((stat, idx) => (
                            <Box key={idx} sx={{ textAlign: 'center' }}>
                              <Typography
                                variant="h3"
                                sx={{
                                  fontWeight: 800,
                                  background: solution.gradient,
                                  backgroundClip: 'text',
                                  WebkitBackgroundClip: 'text',
                                  WebkitTextFillColor: 'transparent',
                                  mb: 0.5
                                }}
                              >
                                {stat.value}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#64748b',
                                  fontWeight: 600,
                                  fontSize: '0.9rem'
                                }}
                              >
                                {stat.label}
                              </Typography>
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Ortak Avantajlar */}
      <Box 
        sx={{ 
          py: { xs: 10, md: 16 },
          background: `
            linear-gradient(
              135deg,
              #ffffff 0%,
              #f8fafc 25%,
              #f1f5f9 50%,
              #e2e8f0 75%,
              #cbd5e1 100%
            )
          `
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Tüm Çözümlerde Ortak Avantajlar
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#64748b',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Hangi çözümü seçerseniz seçin, bu avantajların hepsine sahip olursunuz
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {commonBenefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    background: 'white',
                    border: '1px solid #e2e8f0',
                    borderRadius: 3,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                      borderColor: '#3b82f6'
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: 2,
                      background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                      color: 'white',
                      mb: 3,
                      '& svg': {
                        fontSize: '2rem'
                      }
                    }}
                  >
                    {benefit.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: '#1e293b'
                    }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#64748b',
                      lineHeight: 1.7
                    }}
                  >
                    {benefit.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Başarı Hikayeleri */}
      <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                color: '#1e293b'
              }}
            >
              Müşterilerimizin Başarı Hikayeleri
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#64748b',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Gerçek müşterilerimizden gerçek sonuçlar
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {successStories.map((story, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    background: `linear-gradient(135deg, ${story.color}05, ${story.color}10)`,
                    border: `2px solid ${story.color}30`,
                    borderRadius: 4,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: `linear-gradient(90deg, ${story.color}, ${story.color}dd)`
                    }
                  }}
                >
                  <Chip
                    label={story.type}
                    size="small"
                    sx={{
                      background: story.color,
                      color: 'white',
                      fontWeight: 600,
                      mb: 3
                    }}
                  />
                  
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: '#1e293b'
                    }}
                  >
                    {story.company}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: story.color,
                      mb: 3,
                      fontSize: '1.1rem'
                    }}
                  >
                    {story.result}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: '#475569',
                      lineHeight: 1.7,
                      fontStyle: 'italic',
                      mb: 3,
                      fontSize: '0.95rem'
                    }}
                  >
                    "{story.quote}"
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 'auto' }}>
                    <Avatar
                      sx={{
                        width: 50,
                        height: 50,
                        background: story.color,
                        mr: 2
                      }}
                    >
                      {story.author.charAt(0)}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#1e293b'
                        }}
                      >
                        {story.author}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#64748b'
                        }}
                      >
                        {story.position}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 800,
              mb: 3
            }}
          >
            Sizin İçin Hangi Çözüm İdeal?
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 6,
              opacity: 0.95,
              lineHeight: 1.6,
              maxWidth: 600,
              mx: 'auto'
            }}
          >
            Ücretsiz danışmanlık görüşmesi için bize ulaşın. 
            İhtiyaçlarınıza en uygun çözümü birlikte belirleyelim
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
            <Button
              variant="contained"
              size="large"
              sx={{
                background: 'white',
                color: '#1e40af',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 700,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': {
                  background: '#f8fafc',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Ücretsiz Danışmanlık
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                borderColor: 'white',
                color: 'white',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: 2,
                borderWidth: 2,
                textTransform: 'none',
                '&:hover': {
                  borderWidth: 2,
                  background: 'rgba(255, 255, 255, 0.1)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Tüm Özellikleri Gör
            </Button>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default SolutionsPage;

